import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import { Plugins } from '@capacitor/core';
const { Share } = Plugins;

const w = 300;
const h = 200;
const baseUrl = "https://holly.reli.sh/develop/"

export class MusicGameSharePopup extends HLF.Popup {

    protected _bg = this.addChild(new PIXI.Graphics());
    protected _debugText = this.addChild(HLF.PixiUtils.makeText("Share Popup\n", Constants.FONT_GEL_MED_35, 35, 0x000000));

    constructor() {
        super();
        this._bg.beginFill(0xffffff);
        this._bg.drawRect(-w/2, -h/2, w, h);
        this._bg.endFill();
    }

    protected AnimateIn(pCallback: () => void): void {
        pCallback();
        this.CopyToClipboard(baseUrl + "#" + this._popupData.data);
        this.NativeShare(baseUrl + "#" + this._popupData.data);
    }
    protected AnimateOut(pCallback: () => void): void {
        pCallback();
    }

    protected CopyToClipboard(pText: string) {
        navigator.clipboard.writeText(pText).then(()=>{
            this._debugText.text += "\nLink copied to clipboard";
        }, ()=>{
            this._debugText.text += "\nError copying link to clipboard";
        });
    }

    protected NativeShare(pText: string) {
        Share.share({
            title: 'Holly Hobbie Music Game Prototype',
            text: 'I made a song for you',
            url: pText,
            dialogTitle: 'Share'
        }).then((ret)=>{
            this._debugText.text += "\nOpened native share popup";
        }, (err)=>{
            console.error(err);
            this._debugText.text += "\n" + err;
        });
    }
}